<script setup>

    import { onMounted, onUnmounted, ref } from 'vue'

    import { useClientStore, useMapStore, useViewStore } from '@/Stores'

    import { storeToRefs } from 'pinia'

    import LatteContainer from '@/Components/App/LatteContainer.vue'
    import LatteWhosNearby from '@/Components/Maps/LatteWhosNearby.vue'
    import Loader from '@/Components/App/Loader.vue'

    import { util } from '@/Helpers'

    const mapStore = useMapStore()
    const clientStore = useClientStore()
    const viewStore = useViewStore()

    const { nearbyClients, nearbyError, areaSummary, mapCenter, loading } = storeToRefs(mapStore)
    const { isEmbedded } = storeToRefs(viewStore)

    let address, coffee_user_profile_id

    function getMainDomain(urlString) {
        try {
            const hostname = new URL(urlString).hostname;
            const parts = hostname.split('.');

            // For localhost or IP addresses, use as-is
            if (parts.length <= 2) {
                return hostname;
            }

            // For domain names, take last 2 parts (domain.tld)
            // This allows coffee.lifeworx.lwxdev and latte.coffee.lifeworx.lwxdev to match on lifeworx.lwxdev
            return parts.slice(-2).join('.');
        } catch {
            return null;
        }
    }

    function receiveMessage(event) {

        // Only accept messages from same main domain (allows different subdomains)
        if (getMainDomain(event.origin) !== getMainDomain(window.location.origin)) {
            return false;
        }

        // Only accept string data (should be an address string)
        if (typeof event.data !== 'string' || !event.data?.trim()) {
            return false;
        }

        address = event.data

        coffee_user_profile_id = util.getQueryParam('exclude_client_id')

        loading.value = true
        clientStore.retrieveNearbyClients(address, coffee_user_profile_id).then(response => {

            nearbyError.value = null
            clientStore.hydrateFromNearby(response.data.clients)

            areaSummary.value = response.data.areaSummary

            nearbyClients.value = response.data.clients
            mapCenter.value = {
                address: util.objectifyAddressString(address),
                geo: {
                    lat: parseFloat(response.data.center.geo.lat),
                    lng: parseFloat(response.data.center.geo.lng)
                }
            }

            mapStore.updateMapCenterCache(mapCenter.value)

            loading.value = false

        }).catch((err) => {

            mapCenter.value = {
                address: util.objectifyAddressString(address),
                geo: {
                    lat: 0,
                    lng: 0
                }
            }

            mapStore.updateMapCenterCache(mapCenter.value)

            loading.value = false
            console.error('catching err mapnearby:', err)
            nearbyError.value = err.error

        })

    }

    onMounted(async () => {

        if (isEmbedded.value) {
            window.addEventListener('message', receiveMessage, false)
        }

    })

    onUnmounted(() => {

        if (isEmbedded.value) {
            window.removeEventListener('message', receiveMessage, false)
        }

        mapStore.purge()

    })

</script>

<template>

    <div
        class="mx-auto max-w-7xl"
        :class="{
            'pt-0': isEmbedded,
            'sm:pt-4 md:pt-6 md:px-8': !isEmbedded
        }"
    >

        <div class="mx-auto max-w-5xl">

            <LatteContainer
                id="latte-map-nearby"
                title="Who&apos;s Nearby"
                :forceSingleLineMobileLayout="true"
            >

                <LatteWhosNearby />

            </LatteContainer>

        </div>

    </div>

</template>
